// extracted by mini-css-extract-plugin
export default {"crumbs":"Crumbs_crumbs__caxuQ","active":"Crumbs_active__Dyliv"};